/**
 * Parampara Theme — base JS
 * Vanilla JS only, no dependencies.
 */
(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    initMobileNav();
    initFaqAccordions();
    initAnnouncementBar();
    initCartPage();
    initCommunityGallery();
    initVideoCarousel();
    initStickyHeader();
    initFeaturedCollectionAddToCart();
    initFeaturedCollectionCarousel();
    initProductGallery();
    initPackPicker();
    initProductQtyStepper();
    initCopyCodeButtons();
  });

  /* ---- Sticky/transparent header: add .is-scrolled once page scrolls past hero ---- */
  function initStickyHeader() {
    var header = document.querySelector('[data-site-header]');
    var utilityBar = document.querySelector('[data-announcement-bar]');
    if (utilityBar) {
      var setBarHeight = function () {
        document.documentElement.style.setProperty('--utility-bar-height', utilityBar.offsetHeight + 'px');
      };
      setBarHeight();
      window.addEventListener('resize', setBarHeight);
    }
    if (header) {
      var setHeaderHeight = function () {
        document.documentElement.style.setProperty('--header-height', header.offsetHeight + 'px');
      };
      setHeaderHeight();
      window.addEventListener('resize', setHeaderHeight);
    }
    if (!header || !header.classList.contains('site-header--transparent')) return;
    function onScroll() {
      if (window.scrollY > 40) {
        header.classList.add('is-scrolled');
      } else {
        header.classList.remove('is-scrolled');
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---- Featured collection: carousel arrows + scroll progress ---- */
  function initFeaturedCollectionCarousel() {
    document.querySelectorAll('[data-fc-carousel]').forEach(function (wrap) {
      var track = wrap.querySelector('[data-fc-track]');
      if (!track) return;
      var prev = wrap.querySelector('[data-fc-prev]');
      var next = wrap.querySelector('[data-fc-next]');
      var cardWidth = parseInt(getComputedStyle(wrap).getPropertyValue('--fc-card-width'), 10) || 280;
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -cardWidth, behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: cardWidth, behavior: 'smooth' }); });

      var section = wrap.closest('[id^="featured-collection-"]');
      var progressFill = section ? section.querySelector('[data-fc-progress]') : null;
      if (progressFill) {
        track.addEventListener('scroll', function () {
          var max = track.scrollWidth - track.clientWidth;
          var pct = max > 0 ? (track.scrollLeft / max) * 100 : 0;
          progressFill.style.width = Math.max(8, pct) + '%';
        }, { passive: true });
      }
    });
  }

  /* ---- Featured collection: AJAX add to cart ---- */
  function initFeaturedCollectionAddToCart() {
    var forms = document.querySelectorAll('[data-product-add-form]');
    if (!forms.length) return;
    forms.forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = form.querySelector('[data-add-to-cart]');
        var originalText = btn ? btn.innerHTML : '';
        if (btn) { btn.disabled = true; }
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            id: form.querySelector('[name="id"]').value,
            quantity: 1
          })
        })
          .then(function (res) { return res.json(); })
          .then(function () {
            return fetch('/cart.js').then(function (res) { return res.json(); });
          })
          .then(function (cart) {
            document.querySelectorAll('.cart-count').forEach(function (el) {
              el.textContent = cart.item_count;
            });
            if (btn) { btn.textContent = 'Added!'; }
          })
          .catch(function () {
            if (btn) { btn.innerHTML = originalText; }
            window.location.href = '/cart';
          })
          .finally(function () {
            if (btn) {
              setTimeout(function () {
                btn.disabled = false;
                btn.innerHTML = originalText;
              }, 1500);
            }
          });
      });
    });
  }

  /* ---- Community gallery: horizontal scroll + dot indicators ---- */
  function initCommunityGallery() {
    var track = document.querySelector('[data-community-gallery-track]');
    var dotsWrap = document.querySelector('[data-community-gallery-dots]');
    if (!track || !dotsWrap) return;
    var dots = dotsWrap.querySelectorAll('.community-gallery__dot');
    if (!dots.length) return;

    track.addEventListener('scroll', function () {
      var maxScroll = track.scrollWidth - track.clientWidth;
      var progress = maxScroll > 0 ? track.scrollLeft / maxScroll : 0;
      var index = Math.min(dots.length - 1, Math.round(progress * (dots.length - 1)));
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
      });
    });

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        var maxScroll = track.scrollWidth - track.clientWidth;
        track.scrollTo({ left: (maxScroll / (dots.length - 1)) * i, behavior: 'smooth' });
      });
    });
  }

  /* ---- Video testimonials carousel: prev/next horizontal scroll ---- */
  function initVideoCarousel() {
    var track = document.querySelector('[data-video-carousel-track]');
    if (!track) return;
    var prevBtn = document.querySelector('[data-video-carousel-prev]');
    var nextBtn = document.querySelector('[data-video-carousel-next]');
    if (!prevBtn || !nextBtn) return;

    function scrollByCard(direction) {
      var card = track.querySelector('.video-card');
      var amount = card ? card.getBoundingClientRect().width + 20 : 240;
      track.scrollBy({ left: amount * direction, behavior: 'smooth' });
    }

    prevBtn.addEventListener('click', function () { scrollByCard(-1); });
    nextBtn.addEventListener('click', function () { scrollByCard(1); });
  }

  function initMobileNav() {
    var toggle = document.querySelector('[data-mobile-nav-toggle]');
    var nav = document.querySelector('[data-mobile-nav]');
    if (!toggle || !nav) return;
    toggle.addEventListener('click', function () {
      var isOpen = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  }

  function initFaqAccordions() {
    var items = document.querySelectorAll('[data-faq-item]');
    items.forEach(function (item) {
      var question = item.querySelector('[data-faq-question]');
      if (!question) return;
      question.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');
        items.forEach(function (i) { i.classList.remove('is-open'); });
        if (!isOpen) item.classList.add('is-open');
      });
    });
  }

  function initAnnouncementBar() {
    var bar = document.querySelector('[data-announcement-bar]');
    if (!bar) return;
    var closeBtn = bar.querySelector('[data-announcement-close]');
    if (!closeBtn) return;
    closeBtn.addEventListener('click', function () {
      bar.style.display = 'none';
      try { sessionStorage.setItem('parampara:announcement-closed', '1'); } catch (e) {}
    });
    try {
      if (sessionStorage.getItem('parampara:announcement-closed') === '1') {
        bar.style.display = 'none';
      }
    } catch (e) {}
  }

  /* ---- Cart page: AJAX quantity stepper + remove (Shopify Cart AJAX API) ---- */
  function initCartPage() {
    var section = document.querySelector('[data-cart-section]');
    if (!section) return;

    var moneyFormat = section.getAttribute('data-money-format');

    section.addEventListener('click', function (e) {
      var minus = e.target.closest('[data-quantity-minus]');
      var plus = e.target.closest('[data-quantity-plus]');
      var remove = e.target.closest('[data-remove-item]');

      if (minus || plus) {
        var stepper = e.target.closest('[data-quantity-stepper]');
        var input = stepper.querySelector('[data-quantity-input]');
        var value = parseInt(input.value, 10) || 0;
        value = minus ? Math.max(0, value - 1) : value + 1;
        input.value = value;
        updateLineQuantity(stepper.getAttribute('data-key'), value, stepper.closest('[data-cart-item]'));
      }

      if (remove) {
        var itemEl = remove.closest('[data-cart-item]');
        updateLineQuantity(remove.getAttribute('data-key'), 0, itemEl);
      }
    });

    section.addEventListener('change', function (e) {
      var input = e.target.closest('[data-quantity-input]');
      if (!input) return;
      var stepper = input.closest('[data-quantity-stepper]');
      var value = Math.max(0, parseInt(input.value, 10) || 0);
      input.value = value;
      updateLineQuantity(stepper.getAttribute('data-key'), value, stepper.closest('[data-cart-item]'));
    });

    var discountForm = section.querySelector('[data-discount-form]');
    if (discountForm) {
      discountForm.addEventListener('submit', function (e) {
        e.preventDefault();
        var input = discountForm.querySelector('[data-discount-input]');
        var code = (input.value || '').trim();
        if (!code) return;
        var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
        window.location.href = root.replace(/\/$/, '') + '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(root.replace(/\/$/, '') + '/cart');
      });
    }

    function updateLineQuantity(key, quantity, itemEl) {
      if (itemEl) itemEl.classList.add('is-updating');
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          if (quantity === 0 && itemEl) {
            itemEl.remove();
          }
          renderCartTotals(cart);
          if (cart.item_count === 0) {
            window.location.reload();
          }
        })
        .catch(function () {
          if (itemEl) itemEl.classList.remove('is-updating');
        });
    }

    function formatMoney(cents) {
      var amount = (cents / 100).toFixed(2);
      if (moneyFormat) {
        return moneyFormat.replace('{{amount}}', amount).replace('{{ amount }}', amount);
      }
      return '₹' + amount;
    }

    function renderCartTotals(cart) {
      document.querySelectorAll('[data-cart-item-count]').forEach(function (el) {
        el.textContent = cart.item_count + ' items';
      });
      document.querySelectorAll('[data-cart-item-count-pill]').forEach(function (el) {
        el.textContent = cart.item_count + ' items';
      });
      document.querySelectorAll('[data-cart-subtotal], [data-cart-total]').forEach(function (el) {
        el.textContent = formatMoney(cart.total_price);
      });

      cart.items.forEach(function (item) {
        var row = section.querySelector('[data-cart-item][data-key="' + item.key + '"]');
        if (!row) return;
        var priceEl = row.querySelector('[data-line-price]');
        if (priceEl) priceEl.textContent = formatMoney(item.final_line_price);
        var input = row.querySelector('[data-quantity-input]');
        if (input) input.value = item.quantity;
      });

      var headerCount = document.querySelectorAll('.cart-count');
      headerCount.forEach(function (el) { el.textContent = cart.item_count; });

      section.querySelectorAll('[data-cart-item]').forEach(function (el) {
        el.classList.remove('is-updating');
      });
    }
  }

  /* ---- PDP: product image gallery (thumbnails + prev/next arrows) ---- */
  function initProductGallery() {
    document.querySelectorAll('[data-product-gallery]').forEach(function (gallery) {
      var slides = gallery.querySelectorAll('[data-gallery-slide]');
      var thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
      if (slides.length < 2) return;
      var current = 0;

      function show(index) {
        if (index < 0) index = slides.length - 1;
        if (index >= slides.length) index = 0;
        slides[current].hidden = true;
        slides[current].classList.remove('is-active');
        thumbs[current] && thumbs[current].classList.remove('is-active');
        current = index;
        slides[current].hidden = false;
        slides[current].classList.add('is-active');
        thumbs[current] && thumbs[current].classList.add('is-active');
      }

      thumbs.forEach(function (thumb, i) {
        thumb.addEventListener('click', function () { show(i); });
      });
      var prev = gallery.querySelector('[data-gallery-prev]');
      var next = gallery.querySelector('[data-gallery-next]');
      if (prev) prev.addEventListener('click', function () { show(current - 1); });
      if (next) next.addEventListener('click', function () { show(current + 1); });
    });
  }

  /* ---- PDP: pack picker (variant cards) updates hidden variant id + price + selected-pack banner ---- */
  function initPackPicker() {
    document.querySelectorAll('[data-pack-picker]').forEach(function (picker) {
      var form = picker.closest('form');
      if (!form) return;
      var moneyFormat = picker.getAttribute('data-money-format');
      function formatMoney(cents) {
        var amount = (cents / 100).toFixed(2);
        if (moneyFormat) {
          return moneyFormat.replace('{{amount}}', amount).replace('{{ amount }}', amount);
        }
        return '₹' + amount;
      }
      var variantInput = form.querySelector('[data-product-form-variant-id]');
      var titleEl = form.querySelector('[data-selected-variant-title]');
      var priceEl = form.querySelector('[data-selected-price]');
      var comparePriceEl = form.querySelector('[data-selected-compare-price]');
      var saveEl = form.querySelector('[data-selected-save]');

      picker.querySelectorAll('[data-pack-card]').forEach(function (card) {
        var radio = card.querySelector('.pack-card__radio');
        card.addEventListener('click', function () {
          if (radio.disabled) return;
          picker.querySelectorAll('.pack-card').forEach(function (c) { c.classList.remove('is-selected'); });
          card.classList.add('is-selected');
          radio.checked = true;

          var price = parseInt(radio.getAttribute('data-variant-price'), 10);
          var comparePrice = parseInt(radio.getAttribute('data-variant-compare-price'), 10);

          if (variantInput) variantInput.value = radio.getAttribute('data-variant-id');
          if (titleEl) titleEl.textContent = radio.getAttribute('data-variant-title');
          if (priceEl) priceEl.textContent = formatMoney(price);

          if (comparePrice > price) {
            if (comparePriceEl) { comparePriceEl.textContent = formatMoney(comparePrice); comparePriceEl.hidden = false; }
            if (saveEl) {
              var pct = Math.round(((comparePrice - price) / comparePrice) * 100);
              saveEl.textContent = pct + '% off';
              saveEl.hidden = false;
            }
          } else {
            if (comparePriceEl) comparePriceEl.hidden = true;
            if (saveEl) saveEl.hidden = true;
          }
        });
      });
    });
  }

  /* ---- PDP: quantity stepper ---- */
  function initProductQtyStepper() {
    document.querySelectorAll('[data-qty-stepper]').forEach(function (stepper) {
      var input = stepper.querySelector('[data-qty-input]');
      var decrease = stepper.querySelector('[data-qty-decrease]');
      var increase = stepper.querySelector('[data-qty-increase]');
      if (!input) return;
      decrease && decrease.addEventListener('click', function () {
        var val = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
        input.value = val;
      });
      increase && increase.addEventListener('click', function () {
        var val = (parseInt(input.value, 10) || 1) + 1;
        input.value = val;
      });
    });
  }

  /* ---- Copy-to-clipboard for promo codes ---- */
  function initCopyCodeButtons() {
    document.querySelectorAll('[data-copy-code]').forEach(function (wrap) {
      var btn = wrap.querySelector('[data-copy-code-btn]');
      var code = wrap.getAttribute('data-copy-code');
      if (!btn || !code) return;
      btn.addEventListener('click', function () {
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code);
        }
        var label = btn.querySelector('svg') ? btn.childNodes[btn.childNodes.length - 1] : btn;
        var original = btn.textContent;
        btn.textContent = 'Copied!';
        setTimeout(function () { btn.textContent = original; }, 1500);
      });
    });
  }
})();

/* Bilona journey: force muted autoplay (Safari/iOS ignore the attribute alone) */
(function () {
  function initStepVideos() {
    var vids = document.querySelectorAll('.bilona-step__media video');
    if (!vids.length) return;
    vids.forEach(function (v) {
      v.muted = true;
      v.defaultMuted = true;
      v.setAttribute('playsinline', '');
    });
    var play = function (v) { var p = v.play(); if (p && p.catch) p.catch(function () {}); };
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) play(e.target); else e.target.pause();
        });
      }, { threshold: 0.25 });
      vids.forEach(function (v) { io.observe(v); });
    } else {
      vids.forEach(play);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initStepVideos);
  else initStepVideos();
  document.addEventListener('shopify:section:load', initStepVideos);
})();

/* Video testimonials: tap to play/pause inline, one at a time */
(function () {
  function init(root) {
    (root || document).querySelectorAll('[data-video-card]').forEach(function (card) {
      if (card.dataset.bound) return;
      card.dataset.bound = '1';
      var v = card.querySelector('[data-video-el]');
      if (!v) return;
      card.addEventListener('click', function () {
        if (v.paused) {
          document.querySelectorAll('[data-video-card] video').forEach(function (o) {
            if (o !== v) { o.pause(); o.closest('[data-video-card]').classList.remove('is-playing'); }
          });
          v.muted = false;
          var p = v.play(); if (p && p.catch) p.catch(function () { v.muted = true; v.play(); });
          card.classList.add('is-playing');
        } else {
          v.pause();
          card.classList.remove('is-playing');
        }
      });
      v.addEventListener('ended', function () { card.classList.remove('is-playing'); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
